import { render, staticRenderFns } from "./HistorySlider.vue?vue&type=template&id=84625ac4"
import script from "./HistorySlider.vue?vue&type=script&lang=js"
export * from "./HistorySlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports